const RESUME_KEY = 'signup_resume_state';

const CARD_FIELDS = [
  'number',
  'cvv',
  'holder',
  'expiration_date',
  'expiration_date_0',
  'expiration_date_1',
];

const stripCardFields = (data) => {
  if (!data) return {};
  const cleaned = { ...data };
  CARD_FIELDS.forEach((field) => {
    delete cleaned[field];
  });
  return cleaned;
};

export const saveSignupResumeState = ({ stepPath, data }) => {
  try {
    sessionStorage.setItem(
      RESUME_KEY,
      JSON.stringify({ stepPath, data: stripCardFields(data) })
    );
  } catch (e) {
    // sessionStorage may be unavailable (private mode, quota exceeded)
  }
};

export const readSignupResumeState = () => {
  try {
    const raw = sessionStorage.getItem(RESUME_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
};

export const clearSignupResumeState = () => {
  try {
    sessionStorage.removeItem(RESUME_KEY);
  } catch (e) {
    // swallow
  }
};
